module.exports = __webpack_public_path__ + "static/media/support_2_목표일지정알림.d3da4fba.JPG";